import {
  Input,
  Output,
  Component,
  OnDestroy,
  EventEmitter,
  ChangeDetectionStrategy,
} from '@angular/core';

import { SnTag, SnCamera } from '@lib/api/entities';

@Component({
  selector: 'sn-camera-details',
  templateUrl: './camera-details.component.html',
  styleUrls: ['./camera-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SnCameraDetailsComponent implements OnDestroy {
  @Input() public camera: SnCamera;

  @Output()
  public readonly tagsChanged = new EventEmitter<SnTag[]>();

  constructor() {}

  public ngOnDestroy(): void {
    this.tagsChanged.complete();
  }

  public onTagsChanged(tags: SnTag[]): void {
    this.tagsChanged.next(tags);
  }
}
